import { useState, useEffect, useCallback } from 'react';
import apiClient from '../utils/axiosConfig';
import { BOOKING_LIMIT_MESSAGE } from '../utils/bookingLimits';

const DEFAULT_STATUS = {
  can_book: true,
  is_blacklisted: false,
  daily_actions_used: 0,
  daily_limit: 20,
  message: null,
  loaded: false,
};

export function useBookingLimits(isAuthenticated) {
  const [status, setStatus] = useState(DEFAULT_STATUS);

  const refresh = useCallback(() => {
    if (!isAuthenticated) {
      setStatus({ ...DEFAULT_STATUS, loaded: true });
      return Promise.resolve();
    }
    return apiClient
      .get('/user/booking-limits')
      .then((res) => {
        if (res.data?.success !== false) {
          setStatus({
            can_book: res.data.can_book !== false,
            is_blacklisted: !!res.data.is_blacklisted,
            daily_actions_used: res.data.daily_actions_used || 0,
            daily_limit: res.data.daily_limit || 20,
            message: res.data.message || (!res.data.can_book ? BOOKING_LIMIT_MESSAGE : null),
            loaded: true,
          });
        }
      })
      .catch(() => setStatus({ ...DEFAULT_STATUS, loaded: true }));
  }, [isAuthenticated]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { ...status, refreshBookingLimits: refresh };
}
